import { GetPromotionRepliesQuery } from '@diritto/common/api/PromotionReplyApi';
import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { QueryKey } from 'constants/reactQuery';

export const promotionsQueryKey = {
  promotions: [QueryKey.Promotion] as const,
  promotion: (id: number) => [...promotionsQueryKey.promotions, id] as const,
  promotionItems: (id: number, isActive?: boolean) =>
    [...promotionsQueryKey.promotion(id), QueryKey.PromotionItem, isActive] as const,
  participate: (id: number) => [...promotionsQueryKey.promotion(id), QueryKey.PromotionParticipate] as const,
  participates: (id: number) => [QueryKey.PromotionParticipate, id] as const,
  participatesByUser: (id: number) => [...promotionsQueryKey.participates(id), 'me'] as const,

  promotionReplies: [QueryKey.PromotionReply] as const,
  promotionRepliesList: (query: GetPromotionRepliesQuery & BasePaginatorDto) =>
    [...promotionsQueryKey.promotionReplies, query] as const,

  promotionReplyLikes: [QueryKey.PromotionReply, QueryKey.PromotionReplyLike] as const,
  promotionReplyLikeList: (promotionId: number, promotionReplyIds: string[]) =>
    [...promotionsQueryKey.promotionReplyLikes, promotionId, promotionReplyIds.join('|')] as const,
};
